// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header_partttss{
    padding: 20px 30px;
}
.header_inner{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.header_user{
    display: flex;
    align-items: center;
}

.header_user span{
    display: block;
    font-size: 15px;
    color: #000000;
}

.prf_iconnn{
    width: 32px;
    height: 32px;
    border-radius: 100%;
    margin-left: 20px;
}
.prf_iconnn img{
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.prf_iconnn .btn, .prf_iconnn .btn:hover, .prf_iconnn .btn:focus {
    padding: 0px;
    background: transparent;
    border: 0px;
}
.prf_iconnn .dropdown-menu{
    background: #004aad;
    color: #fff;
}

.prf_iconnn .dropdown-menu .dropdown-item{
    color: #fff;
}
.btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active, .show>.btn-success.dropdown-toggle{
    color: #fff;
    background-color: transparent;
    border-color: transparent;
    box-shadow: none;
}


.modal_close h3{
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    color: #000;
}

.modal_close .close_buuut{
    width: 25px;
    height: 25px;
    text-align: center;
    padding: 0px;
    border:0px;
    background: #f00;
    position: absolute;
    right: -15px;
    top: -15px;
    line-height: 25px;
    border-radius: 100%;
}
.modal_close .close_buuut:after{
    content: "X";
    color: #fff;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.footer_but{
    display: flex;
    justify-content: center;
    align-items: center;
}

.yesbut{
    padding: 0 30px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    font-weight: 600;
    background: #0571b9;
    font-size: 18px;
    text-transform: uppercase;
    margin: 0 10px;
    border: 0px;
}

.nobut{
    padding: 0 30px;
    height: 40px;
    line-height: 40px;
    color: #fff;
    font-weight: 600;
    background: #f00;
    font-size: 18px;
    text-transform: uppercase;
    margin: 0 10px;
    border: 0px;
}
@media screen and (max-width:767px){
    .header_logo{
        max-width: 150px;
        width: 100%;
    }
    .header_logo img{
        width: 100%;
    }
}

@media screen and (max-width:480px){
    .header_partttss{
        padding: 10px 0;
    }
}

@media screen and (max-width:420px){
    .header_logo{
        max-width: 100px;
        width: 100%;
    }
    .header_user span{
        font-size: 13px;
    }
    .prf_iconnn{
        width: 22px;
        height: 22px;
        margin-left: 10px;
    }
    
}`, "",{"version":3,"sources":["webpack://./src/components/layout/header/header.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,uBAAuB;IACvB,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;AACA;IACI,WAAW;IACX,6BAA6B;IAC7B,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,WAAW;AACf;AACA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,WAAW;IACf;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;;AAEJ","sourcesContent":[".header_partttss{\n    padding: 20px 30px;\n}\n.header_inner{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.header_user{\n    display: flex;\n    align-items: center;\n}\n\n.header_user span{\n    display: block;\n    font-size: 15px;\n    color: #000000;\n}\n\n.prf_iconnn{\n    width: 32px;\n    height: 32px;\n    border-radius: 100%;\n    margin-left: 20px;\n}\n.prf_iconnn img{\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n.prf_iconnn .btn, .prf_iconnn .btn:hover, .prf_iconnn .btn:focus {\n    padding: 0px;\n    background: transparent;\n    border: 0px;\n}\n.prf_iconnn .dropdown-menu{\n    background: #004aad;\n    color: #fff;\n}\n\n.prf_iconnn .dropdown-menu .dropdown-item{\n    color: #fff;\n}\n.btn-success:not(:disabled):not(.disabled).active, .btn-success:not(:disabled):not(.disabled):active, .show>.btn-success.dropdown-toggle{\n    color: #fff;\n    background-color: transparent;\n    border-color: transparent;\n    box-shadow: none;\n}\n\n\n.modal_close h3{\n    text-align: center;\n    font-size: 24px;\n    font-weight: 600;\n    color: #000;\n}\n\n.modal_close .close_buuut{\n    width: 25px;\n    height: 25px;\n    text-align: center;\n    padding: 0px;\n    border:0px;\n    background: #f00;\n    position: absolute;\n    right: -15px;\n    top: -15px;\n    line-height: 25px;\n    border-radius: 100%;\n}\n.modal_close .close_buuut:after{\n    content: \"X\";\n    color: #fff;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.footer_but{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.yesbut{\n    padding: 0 30px;\n    height: 40px;\n    line-height: 40px;\n    color: #fff;\n    font-weight: 600;\n    background: #0571b9;\n    font-size: 18px;\n    text-transform: uppercase;\n    margin: 0 10px;\n    border: 0px;\n}\n\n.nobut{\n    padding: 0 30px;\n    height: 40px;\n    line-height: 40px;\n    color: #fff;\n    font-weight: 600;\n    background: #f00;\n    font-size: 18px;\n    text-transform: uppercase;\n    margin: 0 10px;\n    border: 0px;\n}\n@media screen and (max-width:767px){\n    .header_logo{\n        max-width: 150px;\n        width: 100%;\n    }\n    .header_logo img{\n        width: 100%;\n    }\n}\n\n@media screen and (max-width:480px){\n    .header_partttss{\n        padding: 10px 0;\n    }\n}\n\n@media screen and (max-width:420px){\n    .header_logo{\n        max-width: 100px;\n        width: 100%;\n    }\n    .header_user span{\n        font-size: 13px;\n    }\n    .prf_iconnn{\n        width: 22px;\n        height: 22px;\n        margin-left: 10px;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
